<div class="content-with-filled-button">

    <h1 class="title">{{ copyService.copies.comprar_cartera_title }}</h1>

    <p class="sub-title">{{ copyService.copies.comprar_cartera_sub_title }}</p>
    <style>
      /* Chrome, Safari, Edge, Opera */
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      
      /* Firefox */
      input[type=number] {
        -moz-appearance: textfield;
      }
      </style>
    <form id="formMeses" class="form row" [formGroup]="formGroup">

        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        
         <!--  <vcl-form-field  class="label" label="valor de las cuotas que pagas mensualmente"
            msgErr="Ingesa un monto mayor o igual a $10,000">
            
                             <input  vclInput placeholder="$0"
              id="inputValueMeses"  maxlength="999999999" type="number" min="0"
              formControlName="plazo" 
              (keyup)="updateValuemonto($event)" 
              (input)="reactiveInputChangeMonto()"
              [option]="option"
             >
              onkeypress="return !(event.charCode == 46)" step="1" -->
             
          <!-- </vcl-form-field> -->
          <vcl-form-field class="label" label="valor de las cuotas que pagas mensualmente"
              description="Desde 10 mil pesos."
              msgErr="Ingesa un monto mayor o igual a $10,000">
              <input vclInput placeholder="$0"
                id="inputValueMonto"  [option]="option"
                (input)="reactiveInputChangeMonto()" 
                formControlName="monto"
                (keyup)="updateValuemonto($event)"
                >  
                <!-- onkeypress="return !(event.charCode == 46)" 
                (change)="reactiveInputChangeAmount()"
                -->
            </vcl-form-field>
        </div>

    </form>
                 
         <br>
                  
                  <p class="bottom1" >{{ copyService.copies.comprar_cartera_bottom_title1 }}</p>
                 
                  <p class="bottom2" >{{ copyService.copies.comprar_cartera_bottom_title2 }}</p>
                  <p class="bottom3" >{{ copyService.copies.comprar_cartera_bottom_title3  }}</p>
       
     
 
    

<app-controls id="docIntroBtns" [hasPrevious]="true" 
(next)="next()" [nextDisabled]="!formGroup.valid">
</app-controls>
